import { rei } from "@/services/api"

class RelatorioImpressosSeguranca {
  static getPdfImpressosSeguranca (busca) {
    return rei
      .post(`relatorio-impressos-seguranca`, busca, { responseType: 'arraybuffer' })
      .then(res => {
        let blob = new Blob([res.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static getItensRelatorio (busca) {
    return rei.post(`papel-seguranca/itens/relatorio`, busca)
              .then(res => res)
  }
}

export default RelatorioImpressosSeguranca
